import {
  AutoConf,
  ImportLinksResult,
  ImportParseResult,
  Result,
  ResultList,
  Search,
} from "core/types/search.types";

export const transformResult = (data: any): Result => ({
  description: data?.description,
  link: data?.link,
  thumbnail: data?.thumbnail,
  title: data?.title,
  signaled: data?.signaled,
  sentiment: data?.sentiment,
});

export const transformSearch = (data: any): Search => ({
  id: data?.id,
  fullName: data?.full_name,
  userId: data?.user_id,
  params: data?.params,
  // results puo' essere assente (es. risposta {message,id} di newSearch) o
  // arrivare a tranche durante la ricerca progressiva: fallback a [] per non rompere.
  results: (data?.results ?? []).map((result: any) => transformResult(result)),
  status: data?.status,
  // Modalita' Social (additiva): pass-through, assenti per le altre modalita'.
  results_by_platform: data?.results_by_platform,
  quota_exceeded_platforms: data?.quota_exceeded_platforms,
});

export const transformResults = (data: any): ResultList[] =>
  data?.map((result: any) => transformResultForList(result));

export const transformResultForList = (data: any): ResultList => ({
  fullName: data?.full_name,
  searchCreationTime: data?.search_creation_time,
  searchId: data?.search_id,
  userId: data?.user_id,
  params: data?.params,
});

export const transformAutoConf = (data: any): AutoConf => ({
  id: data?.id,
  fullName: data?.full_name,
  params: data?.params?.map((p: any) => ({ id: p?.id, name: p?.name })),
});

export const transformImportParse = (data: any): ImportParseResult => ({
  items: (data?.items ?? []).map((item: any) => ({
    row: item?.row,
    url: item?.url,
    normalizedUrl: item?.normalized_url,
    note: item?.note ?? "",
    duplicate: item?.duplicate ?? null,
  })),
  skipped: (data?.skipped ?? []).map((row: any) => ({
    row: row?.row,
    reason: row?.reason,
    text: row?.text ?? "",
  })),
  totalRows: data?.total_rows ?? 0,
  // il backend dice quanti link accetta per chiamata; 25 se non lo dice
  maxItemsPerCall: data?.max_items_per_call ?? 25,
});

export const transformImportLinks = (data: any): ImportLinksResult => ({
  added: (data?.added ?? []).map((a: any) => ({
    url: a?.url,
    title: a?.title,
    previewOk: !!a?.preview_ok,
  })),
  duplicates: data?.duplicates ?? [],
  failed: (data?.failed ?? []).map((f: any) => ({
    url: f?.url,
    reason: f?.reason,
  })),
});
